import { useLogging } from "../../../../../Shared/hooks/useLogging/useLogging";
import { getGiftCardByNumber } from "./PaymentMethodFetch-utils";
/**
 * Hook for gift card lookup functionality.
 *
 * Note: Payment methods are now automatically hydrated via SWR.
 * Use usePaymentMethods() from SWR/Payments/usePaymentMethods.ts for payment data.
 */
export const usePaymentMethodFetch = () => {
    const { datadogLog } = useLogging();
    return {
        getGiftCardByNumber: getGiftCardByNumber(datadogLog),
    };
};
